module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("euBXr"))).then(() => parcelRequire('tCnJp'));